<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close" @click.prevent="$close(noValue)">
          ×
        </button>
      </div>
      <div class="modal-body">
        <p class="m-0" v-html="content"></p>
      </div>
      <div class="modal-footer">
        <ts-button outline @click="$close(noValue)">
          {{ no }}
        </ts-button>
        <ts-button :color="buttonColor" @click="$close(yesValue)">
          {{ yes }}
        </ts-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    type: {
      type: String,
      default: ''
    },
    title: String,
    content: String,
    yes: {
      type: String,
      default: 'Yes'
    },
    yesValue: {
      default: true
    },
    no: {
      type: String,
      default: 'No'
    },
    noValue: {
      default: false
    }
  },
  computed: {
    buttonColor() {
      if (this.type === 'danger') {
        return 'danger'
      }

      return 'primary'
    }
  }
}
</script>

<style lang="sass" scoped>
.modal-header,
.modal-footer
  border: none
</style>
